export const menuItems = [
    {
      title: "Loans",
      links: [
        { label: "EMI Calculator", to: "/emi-calculator.html" },
        { label: "Loan Comparison Calculator", to: "/loan-comparision-calculator.html" }
      ]
    },
    {
      title: "Investments",
      links: [
        { label: "SIP Calculator", to: "/sip-calculator.html" },
        { label: "Step-Up SIP Calculator", to: "/stepup-sip-calculator.html" },
        { label: "Goal Amount Calculator", to: "/goal-sip-calculator.html" },
        { label: "Lumpsum Calculator", to: "/lumpsum-calculator.html" },
        { label: "SWP Calculator", to: "/swp-calculator.html" }
      ]
    },
    {
      title: "Tools",
      links: [
        { label: "Interest Calculator ", to:"/interestCalculator.html" }
      ]
    },
    {
      title: "Savings",
      links: [
        { label: "FD Calculator", to: "/fixed-deposit-calculator.html" },
        { label: "RD Calculator", to: "/recurring-deposit.html" }
      ]
    },
    
  ];
  